import React, { useEffect, useState } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import cls from 'classnames';

import messages from './messages';

import services from 'Lib/services';

const translations = services.translationService();

export default ({ authorityData, requestData }) => {
  const { request_id, token, status } = requestData;
  const [message, setMessage] = useState({ id: 'none', defaultMessage: 'none' });
  useEffect(() => {
    if (status) {
      setMessage(messages.applicationSuccess);
    } else {
      setMessage(messages.applicationAlreadySuccess);
    }
  }, []);
  return (
    <div className="col-md-12 result">
      {(authorityData && (
        <h3 className={cls(status ? 'text-success' : 'text-danger')}>
          <FormattedHTMLMessage {...message} values={{ title: authorityData.title }} />
        </h3>
      )) || (
        <h3 className={cls(status ? 'text-success' : 'text-danger')}>
          <FormattedHTMLMessage {...message} values={{ title: translations['apps.mainFormTitle'] }} />
        </h3>
      )}
      <div className={cls('panel', 'request-sent', status ? 'panel-success' : 'panel-danger')}>
        <div className="panel-heading">
          <div className="panel-title">
            <FormattedMessage {...messages.pleaseSave} />
          </div>
        </div>
        <div className="panel-body">
          <table id="print" className="table table-bordered table-hover table-bordered">
            <tbody>
              <tr>
                <td>
                  <FormattedMessage {...messages.applicationNo} />
                </td>
                <td>{request_id}</td>
              </tr>
              <tr>
                <td>
                  <FormattedMessage {...messages.applicationToken} />
                </td>
                <td>{token}</td>
              </tr>
            </tbody>
          </table>
          {/* <button id="print" className="btn btn-primary pull-right" onClick="printContent('print')">
                  <span className="glyphicon glyphicon-print" aria-hidden="true"></span>
                  <FormattedMessage {...messages.printButton} />
              </button> */}
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/application-form/submitted.js